<div *ngIf="isVisible || loading" class="header header-main" [ngClass]="{ 'header--scrolling': isScrolling }">
  <div class="header-container container" [class.loading]="loading">
    <div class="d--flex">
      <div class="header-logo">
        <a [airLink]="themeHomePageUrl" [userEventSource]="userEventSource" userEventLabel="Theme home">
          <div class="logo--air-miles"></div>
        </a>
      </div>
      <div class="header-logo">
        <a [airLink]="themeHomePageUrl" [userEventSource]="userEventSource" userEventLabel="Theme home">
          <div class="logo--shell"></div>
        </a>
      </div>
    </div>

    <!-- Public menu navigation -->
    <ng-container *ngIf="publicMenuLinks?.length">
      <air-navigation
        [name]="'public'"
        [navigationItems]="publicMenuLinks"
        class="d--none--sm"
        [userEventSource]="userEventSource"
      ></air-navigation>
      <air-hamburger-navigation
        [menuLinks]="publicMenuLinks"
        class="d--none d--block--sm"
        [userEventSource]="userEventSource"
      ></air-hamburger-navigation>
    </ng-container>
    <air-language-switcher></air-language-switcher>
  </div>
</div>
